let mobileFooterToggle = $('.nav-group-mobile-toggle');

mobileFooterToggle.on('click', function() {
    let footerGroup = $(this).closest('.nav-group');

    if(footerGroup.hasClass('open')) {
        footerGroup.removeClass('open');
        footerGroup.find('ul').slideUp();
    } else {
        footerGroup.addClass('open');
        footerGroup.find('ul').slideDown();
    }
});
